<template>
  <div class="row p-0 g-0 h-100">
    <div class="col-12 p-0 h-100">
      <section class="d-flex flex-column h-100" style="overflow-y:hidden">
        <AdminNavbar class="flex-initial"/>
        <router-view 
          class="flex-grow-1 admin-main-content"
          style="overflow-y: auto; max-height: 100%;"
          />
        <AdminFooter class="flex-initial" />
      </section>
    </div>
  </div>
</template>

<script>
import AdminFooter from "@/views/components/admin/AdminFooter.vue";
import AdminNavbar from "@/views/components/admin/AdminNavbar.vue";

export default {
  name: "AdminContentLayout",
  components: {
    AdminFooter,
    AdminNavbar,
  },
  data() {
    return {
      // drawer: false,
    };
  },
};
</script>
<style scoped>
/* Use /deep/ selector to override the v-application__wrap class */
</style>
